import { connect } from 'react-redux';
import { appActions } from 'App/duck';
import ChatFeedComponent from './ChatFeedComponent';

import { chatFeedActions, chatFeedOperations } from './duck';

const mapStateToProps = ({
  chatFeedReducer: { chats, active, readReceipts },
  locationReducer,
  appReducer,
}) => ({
  active,
  chatList: chats?.data || [],
  loading: chats?.loading ?? true,
  apiCalled: chats?.apiCalled ?? false,
  locationId: locationReducer.location_code,
  locationData: locationReducer.location_data,
  plans: appReducer.plans.data,
});

const mapDispatchToProps = (dispatch) => {
  const fetchChatSessions = () => {
    dispatch(chatFeedOperations.fetchChatSessions());
  };

  const clearActiveDelete = () => {
    dispatch(chatFeedActions.clearActiveDelete());
    dispatch(chatFeedActions.updateActiveError(false));
  };
  const deletePost = (postId, lastPost) => {
    dispatch(chatFeedOperations.deletePost(postId, lastPost));
  };

  const getPlans = (locationId) => {
    dispatch(subscriptionOperations.fetchPlans(locationId));
  };

  return {
    fetchChatSessions,
    clearActiveDelete,
    deletePost,
    getPlans,
  };
};

const ChatFeedContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatFeedComponent);

export default ChatFeedContainer;
